import mhiImages from "./mhi";
import pdvendImages from "./pdvend";

const imagesMap = {
  PDVEND: pdvendImages,
  MHI: mhiImages
};

const images = imagesMap[process.env.REACT_APP_WHITELABEL_NAME];

export default images;



// WEBPACK FOOTER //
// ./src/assets/images/index.js